export const PREFIX = "smart-search-ks"

export const CONTAINER_LIST_CLASS = `container-${PREFIX}`
export const ITEM_LIST_CLASS = `item-${PREFIX}`
export const TITLE_ITEM_LIST_CLASS = `title-item-${PREFIX}`

export const VIRTUAL_LIST_CLASS = "rc-virtual-list"

export const LIST_MENU_DROPDOWN_SMART_SEARCH_ID = "ListMenuDropdownSmartSearch"
